import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { Document, Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer"
import moment from "moment/moment"
import mylerzLogo from "../../../assets/images/mylerz-logo.png"

// Import service

const styles = StyleSheet.create({
  page: {
    padding: 36,
  },
  refSection: {
    padding: 8,
    textAlign: "center",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  headerSection: {
    padding: 8,
    textAlign: "center",
    border: "1px solid #000",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    maxHeight: 150,
  },
  wrapDetails: {
    display: "flex",
    flexDirection: "row",
    textAlign: "center",
    alignItems: "center",
    justifyContent: "space-between",
  },
  wrapScanSection: {
    display: "flex",
    flexDirection: "row",
    textAlign: "center",
    alignItems: "flex-start",
    gap: 8,
  },
  bodyContainer: {
    padding: 8,
    marginTop: 10,
    marginBottom: 10,
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
  },
  rowTable: {
    display: "flex",
    flexDirection: "row",
    border: "1px solid #000",
    borderBottom: 0,
  },
  colTable: {
    padding: 4,
    paddingLeft: 8,
    display: "flex",
    width: "10%",
    borderRight: "1px solid #000",
  },
  body1: {
    color: "#000",
    fontSize: 16,
    marginTop: 2,
    marginBottom: 2,
  },
  body2: {
    color: "#505050",
    fontSize: 14,
    marginTop: 2,
    marginBottom: 2,
  },
  bodyBlack: {
    color: "#000",
    fontSize: 14,
    marginTop: 2,
    marginBottom: 2,
  },
  paragraph: {
    color: "#000",
    fontSize: 12,
    marginTop: 2,
    marginBottom: 2,
  },
  logo: {
    fontSize: 48,
    paddingLeft: 5,
    paddingRight: 5,
    maxWidth: 84,
    maxHeight: 84,
  },
  qrcode: {
    maxWidth: 64,
    maxHeight: 64,
  },
  barcode: {
    maxWidth: 128,
  },
  hrLine: {
    marginTop: 6,
    borderTop: "1px dashed #000",
  },
  billContainer: {
    marginTop: 7,
    marginBottom: 7,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  companyNameHolder: {
    marginTop: 6,
    padding: 8,
    width: 200,
    textAlign: "center",
    border: "1px solid #000",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    maxHeight: 150,
  },
  billHolder: {
    marginLeft: 80,
  },
  dateBill: {
    color: "#000",
    fontSize: 11,
    marginTop: 2,
    marginBottom: 2,
    marginLeft: 100,
  },
  SecondbillContainer: {
    marginTop: 30,
    padding: 8,
    marginBottom: 11,
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
  },
  boderClientBox: {
    width: 400,
    padding: 8,
    marginLeft: 80,
    border: "1px solid #000",
  },
  footer: {
    position: "absolute",
    borderTop: "1px solid #000",
    bottom: 20,
    left: 20,
    right: 20,
    marginTop: 15,
    textAlign: "center",
    fontSize: 10,
    color: "#000",
  },
})

function calculateTotalWithTax(price = 0) {
  const taxPercent = 19
  const tax = (price * taxPercent) / 100
  return price - tax
}

export function PackageDocumentMylrez(props) {
  const { dataDocument, generatedQRCode, generatedBarcode } = props
  const RESOURCE_URL =
    process.env.REACT_APP_BASE_RESOURCE_URL || "https://api.colis.resuxishop.com/qr-images"
  const date = moment(dataDocument.createdAt).format("DD/MM/YYYY")
  const dateYear = moment(dataDocument.createdAt).format("YYYY")
  const fullAddress = `${dataDocument.city} - ${dataDocument.address}`
  return (
    <Document title="Alamana Colis" language="en" subject="Alamana package order">
      <Page size="A4" style={styles.page}>
        <View style={styles.refSection}>
          <Text style={styles.body1}>BLN: BL-{dataDocument.reference}</Text>
          <Text style={styles.body1}>Date: {date}</Text>
        </View>

        <View style={styles.headerSection}>
          <View style={styles.wrapDetails}>
            {/* <View> */}
            {/* <Text style={styles.logo}>A</Text> */}
            <Image style={styles.logo} src={mylerzLogo} />
            {/* </View> */}
            <View>
              <Text style={styles.paragraph}>BLN: BL-{dataDocument.reference}</Text>
              <Text style={styles.paragraph}>DATE: {date}</Text>
              <Text style={styles.paragraph}>DISPATCH: C-0</Text>
            </View>
          </View>
          {generatedQRCode !== "" && generatedBarcode !== "" && (
            <View style={styles.wrapScanSection}>
              <Image style={styles.qrcode} src={`${RESOURCE_URL}/${generatedQRCode}.jpg`} />
              <Image style={styles.barcode} src={`${RESOURCE_URL}/${generatedBarcode}.jpg`} />
            </View>
          )}
        </View>

        <View style={styles.bodyContainer}>
          <View>
            <Text style={styles.body1}>EXPEDITEUR</Text>
            <Text style={styles.body2}>Nom: Société Resuxi</Text>
            <Text style={styles.body2}>Telephone :55690494</Text>
            <Text style={styles.body2}>MF: 1658041/T/N/M/000</Text>
            <Text style={styles.body2}>Adresse: Sousse ville</Text>
          </View>
          <View>
            <Text style={styles.body1}>DESTINATAIRE</Text>
            <Text style={styles.body2}>Nom: {dataDocument.clientName}</Text>
            <Text style={styles.body2}>Telephone: {dataDocument.clientPhoneNumber}</Text>
            <Text style={styles.body2}>État: {dataDocument.state}</Text>
            <Text style={styles.body2}>Adresse: {fullAddress}</Text>
          </View>
        </View>

        <View>
          <View style={styles.rowTable}>
            <View
              style={{
                ...styles.colTable,
                width: "25%",
              }}
            >
              <Text style={styles.paragraph}>Référence</Text>
            </View>
            <View
              style={{
                ...styles.colTable,
                width: "45%",
              }}
            >
              <Text style={styles.paragraph}>Designation</Text>
            </View>
            <View style={styles.colTable}>
              <Text style={styles.paragraph}>P.U</Text>
            </View>
            <View style={styles.colTable}>
              <Text style={styles.paragraph}>Qté</Text>
            </View>
            <View
              style={{
                ...styles.colTable,
                border: 0,
              }}
            >
              <Text style={styles.paragraph}>Total.U</Text>
            </View>
          </View>
          <View style={styles.rowTable}>
            <View
              style={{
                ...styles.colTable,
                width: "25%",
              }}
            >
              <Text style={styles.paragraph}>{dataDocument.reference}</Text>
            </View>
            <View
              style={{
                ...styles.colTable,
                width: "45%",
              }}
            >
              <Text style={styles.paragraph}>{dataDocument.description}</Text>
            </View>
            <View style={styles.colTable}>
              <Text style={styles.paragraph}>{dataDocument.packagePrice.toFixed(2)}</Text>
            </View>
            <View style={styles.colTable}>
              <Text style={styles.paragraph}>{dataDocument.productQuantity}</Text>
            </View>
            <View
              style={{
                ...styles.colTable,
                border: 0,
              }}
            >
              <Text style={styles.paragraph}>{calculateTotalWithTax(dataDocument.packagePrice).toFixed(2)}</Text>
            </View>
          </View>
          <View style={styles.rowTable}>
            <View
              style={{
                ...styles.colTable,
                width: "80%",
                backgroundColor: "#E6E6E6",
              }}
            >
              <Text style={styles.paragraph}>Autoriser l'ouverture du colis : Non</Text>
            </View>
            <View style={styles.colTable}>
              <Text style={styles.paragraph}>Total</Text>
            </View>
            <View
              style={{
                ...styles.colTable,
                border: 0,
              }}
            >
              <Text style={styles.paragraph}>{calculateTotalWithTax(dataDocument.packagePrice).toFixed(2)}</Text>
            </View>
          </View>
          <View style={styles.rowTable}>
            <View
              style={{
                ...styles.colTable,
                width: "80%",
                backgroundColor: "#E6E6E6",
              }}
            >
              <Text style={styles.paragraph}>Nombre: 1/1</Text>
            </View>
            <View style={styles.colTable}>
              <Text style={styles.paragraph}>TVA</Text>
            </View>
            <View
              style={{
                ...styles.colTable,
                border: 0,
              }}
            >
              <Text style={styles.paragraph}>19%</Text>
            </View>
          </View>
          <View
            style={{
              ...styles.rowTable,
              borderBottom: "1px solid #000",
            }}
          >
            <View
              style={{
                ...styles.colTable,
                width: "80%",
              }}
            >
              <Text style={styles.body1}>{dataDocument.exchange === 1 ? "ECHANGE" : ""} </Text>
            </View>
            <View style={styles.colTable}>
              <Text style={styles.paragraph}>COD</Text>
            </View>
            <View
              style={{
                ...styles.colTable,
                border: 0,
              }}
            >
              <Text style={styles.paragraph}>{dataDocument.packagePrice.toFixed(2)}</Text>
            </View>
          </View>
        </View>
        <View style={styles.hrLine}></View>

        <View style={styles.billContainer}>
          <View style={styles.companyNameHolder}>
            <View>
              <Text style={styles.body1}>Société Resuxi</Text>
            </View>
          </View>
          <View style={styles.billHolder}>
            <Text style={styles.body1}>FACTURE</Text>
            <Text style={styles.dateBill}>Date: {date}</Text>
          </View>
        </View>

        <View style={styles.bodyContainer}>
          <View>
            <Text style={styles.bodyBlack}>
              Facture N° : {dateYear}/{dataDocument.reference}
            </Text>
          </View>
          <View style={styles.boderClientBox}>
            <Text style={styles.bodyBlack}>Client: {dataDocument.clientName}</Text>
            <Text style={styles.bodyBlack}>Telephone: {dataDocument.clientPhoneNumber}</Text>
            <Text style={styles.bodyBlack}>Adresse: {fullAddress}</Text>
          </View>
        </View>

        <View>
          <View style={styles.rowTable}>
            <View
              style={{
                ...styles.colTable,
                width: "25%",
              }}
            >
              <Text style={styles.paragraph}>Référence</Text>
            </View>
            <View
              style={{
                ...styles.colTable,
                width: "45%",
              }}
            >
              <Text style={styles.paragraph}>Designation</Text>
            </View>
            <View style={styles.colTable}>
              <Text style={styles.paragraph}>P.U</Text>
            </View>
            <View style={styles.colTable}>
              <Text style={styles.paragraph}>Qté</Text>
            </View>
            <View
              style={{
                ...styles.colTable,
                border: 0,
              }}
            >
              <Text style={styles.paragraph}>Total.U</Text>
            </View>
          </View>
          <View style={styles.rowTable}>
            <View
              style={{
                ...styles.colTable,
                width: "25%",
              }}
            >
              <Text style={styles.paragraph}>{dataDocument.reference}</Text>
            </View>
            <View
              style={{
                ...styles.colTable,
                width: "45%",
              }}
            >
              <Text style={styles.paragraph}>{dataDocument.description}</Text>
            </View>
            <View style={styles.colTable}>
              <Text style={styles.paragraph}>{dataDocument.packagePrice.toFixed(2)}</Text>
            </View>
            <View style={styles.colTable}>
              <Text style={styles.paragraph}>{dataDocument.productQuantity}</Text>
            </View>
            <View
              style={{
                ...styles.colTable,
                border: 0,
              }}
            >
              <Text style={styles.paragraph}>{calculateTotalWithTax(dataDocument.packagePrice).toFixed(2)}</Text>
            </View>
          </View>
          <View style={styles.rowTable}>
            <View
              style={{
                ...styles.colTable,
                width: "80%",
                backgroundColor: "#E6E6E6",
              }}
            >
              <Text style={styles.paragraph}>Autoriser l'ouverture du colis : Non</Text>
            </View>
            <View style={styles.colTable}>
              <Text style={styles.paragraph}>Total</Text>
            </View>
            <View
              style={{
                ...styles.colTable,
                border: 0,
              }}
            >
              <Text style={styles.paragraph}>{calculateTotalWithTax(dataDocument.packagePrice).toFixed(2)}</Text>
            </View>
          </View>
          <View style={styles.rowTable}>
            <View
              style={{
                ...styles.colTable,
                width: "80%",
                backgroundColor: "#E6E6E6",
              }}
            >
              <Text style={styles.paragraph}>Nombre: 1/1</Text>
            </View>
            <View style={styles.colTable}>
              <Text style={styles.paragraph}>TVA</Text>
            </View>
            <View
              style={{
                ...styles.colTable,
                border: 0,
              }}
            >
              <Text style={styles.paragraph}>19%</Text>
            </View>
          </View>
          <View
            style={{
              ...styles.rowTable,
              borderBottom: "1px solid #000",
            }}
          >
            <View
              style={{
                ...styles.colTable,
                width: "80%",
              }}
            >
              <Text style={styles.body1}>{dataDocument.exchange === 1 ? "ECHANGE" : ""} </Text>
            </View>
            <View style={styles.colTable}>
              <Text style={styles.paragraph}>COD</Text>
            </View>
            <View
              style={{
                ...styles.colTable,
                border: 0,
              }}
            >
              <Text style={styles.paragraph}>{dataDocument.packagePrice.toFixed(2)}</Text>
            </View>
          </View>
        </View>
        <View style={styles.footer}>
          <Text>Société Resuxi Mobile : 55690494{"\n"}MF : 1658041/T/N/M/000</Text>
        </View>
      </Page>
    </Document>
  )
}

// Setting default values for the props of PackageDocument
PackageDocumentMylrez.defaultProps = {}

// Typechecking props of the PackageDocument
PackageDocumentMylrez.propTypes = {
  dataDocument: PropTypes.shape({
    reference: PropTypes.string.isRequired,
    barcode: PropTypes.string.isRequired,
    clientName: PropTypes.string.isRequired,
    clientPhoneNumber: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    productQuantity: PropTypes.number.isRequired,
    packagePrice: PropTypes.number.isRequired,
    state: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    exchange: PropTypes.number.isRequired,
    address: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
  }).isRequired,
  generatedQRCode: PropTypes.string.isRequired,
  generatedBarcode: PropTypes.string.isRequired,
}
